const env = {
    NODE_ENV: process.env.REACT_APP_NODE_ENV || 'local' as 'local' | 'staging' | 'production',
    API_URL: process.env.REACT_APP_API_URL || '',
    SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN || '',
    ONESIGNAL_ID: process.env.REACT_APP_ONESIGNAL_ID || '',
};

export default env;